import { groupTranslate } from 'lib/svg-helpers';
import ShaftGraphic from './ShaftGraphic';

export default function PushPierGraphic({
  offsetX, offsetY, factorY,
  load: {aboveGrade=0, depth, coating, product: {diameter}={}}
}) {
  if (!diameter) return null;

  return (
    <g transform={groupTranslate()(offsetX, offsetY)} className={coating}>
      <ShaftGraphic
        diameter={diameter}
        shaftLength={depth}
        aboveGrade={aboveGrade}
        factorY={factorY}
        type="PushPier"/>
    </g>
  );
};
